exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".md-direction-bottom-right{width:25%!important}.mrgtop-2per{margin-top:1%}.mrgtop-5px{margin-top:5px}.box{margin-top:5%}.center{text-align:center}.heght-1px{height:1px}.b-form-input-container{margin:4px 0 5px!important}.md-button-color{background-color:#607d8d!important}.mx-input-icon__calendar{margin-top:0!important}.error{color:red}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-fedf7626","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/view/vehicleQuotation/goodsReceivedview.vue
// module id = 1857
// module chunks = 0